var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-indicator",class:{ large: !!_vm.large },style:(_vm.styles),attrs:{"role":"progressbar"}},_vm._l((_vm.pips),function(pip,index){return _c('div',{key:index,class:pip})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }